import { ChecklistItems } from '../../../api/configurations/checklist/types';
import { usePaths } from '../../../routes/routesHelper';
import { SettingsLinks } from './types';

type Paths = ReturnType<typeof usePaths>;

const loginMethodOptions = [ChecklistItems.SELECTED_LOGIN_METHOD, ChecklistItems.SET_CALLBACK_URL];
const secureOptions = [ChecklistItems.SET_UP_OAUTH, ChecklistItems.COPY_SECRET_KEY];
const authenticationOptions = [ChecklistItems.CONNECTED_SOCIAL, ChecklistItems.MISCELLANEOUS_DATA];
const userDataBaseOptions = [ChecklistItems.SET_UP_STORAGE, ChecklistItems.SUPPLEMENTARY_INFO];
const customizationOptions = [ChecklistItems.WIDGET_CUSTOMIZATION];

export const checkListOptions = {
  'login-method': loginMethodOptions,
  secure: secureOptions,
  authentication: authenticationOptions,
  'user-data-base': userDataBaseOptions,
  customization: customizationOptions
};

const shadowLoginMethodOptions = [ChecklistItems.SET_CALLBACK_URL];
const shadowSecureOptions = [ChecklistItems.SET_UP_OAUTH, ChecklistItems.COPY_SECRET_KEY];

export const shadowLoginOptions = {
  'login-method': shadowLoginMethodOptions,
  secure: shadowSecureOptions
};

export const getSettingsPageLinks = (paths: Paths): SettingsLinks => ({
  [ChecklistItems.SELECTED_LOGIN_METHOD]: paths.navigationPath,
  [ChecklistItems.SET_CALLBACK_URL]: paths.callbackUrlsSettingsPath,
  [ChecklistItems.SET_UP_OAUTH]: paths.oauthPath,
  [ChecklistItems.COPY_SECRET_KEY]: paths.signaturePath,
  [ChecklistItems.CONNECTED_SOCIAL]: paths.socialConnectionPath,
  [ChecklistItems.MISCELLANEOUS_DATA]: paths.miscellaneousPath,
  [ChecklistItems.SET_UP_STORAGE]: paths.userDataStoragePath,
  [ChecklistItems.SUPPLEMENTARY_INFO]: null,
  [ChecklistItems.WIDGET_CUSTOMIZATION]: paths.customizeWidgetPath
});
